import { useThemeTokens } from '@providers/themeTokenProvider';

export type AccordionTokens = {
  accordion: {
    borderRadius?: string;
    borderColor?: string;
    multipleBorderColor?: string;
    progressBar?: {
      supportColors?: {
        activeSupportColorOne?: string;
        activeSupportColorTwo?: string;
        activeSupportColorThree?: string;
        activeSupportColorFour?: string;
        activeSupportColorFive?: string;
        activeSupportColorSix?: string;
        inactiveSupportColorOne?: string;
        inactiveSupportColorTwo?: string;
        inactiveSupportColorThree?: string;
        inactiveSupportColorFour?: string;
        inactiveSupportColorFive?: string;
        inactiveSupportColorSix?: string;
      };
      supportPositiveColors?: {
        activeSupportColorOne?: string;
        activeSupportColorTwo?: string;
        activeSupportColorThree?: string;
        activeSupportColorFour?: string;
        activeSupportColorFive?: string;
        activeSupportColorSix?: string;
        inactiveSupportColorOne?: string;
        inactiveSupportColorTwo?: string;
        inactiveSupportColorThree?: string;
        inactiveSupportColorFour?: string;
        inactiveSupportColorFive?: string;
        inactiveSupportColorSix?: string;
      };
      supportNegativeColors?: {
        activeSupportColorOne?: string;
        activeSupportColorTwo?: string;
        activeSupportColorThree?: string;
        activeSupportColorFour?: string;
        activeSupportColorFive?: string;
        activeSupportColorSix?: string;
        inactiveSupportColorOne?: string;
        inactiveSupportColorTwo?: string;
        inactiveSupportColorThree?: string;
        inactiveSupportColorFour?: string;
        inactiveSupportColorFive?: string;
        inactiveSupportColorSix?: string;
      };
    };
  };
};

export const useAccordionTokens = (): AccordionTokens => {
  const baseTokens = useThemeTokens();
  const { sys } = baseTokens;
  const comp: AccordionTokens = {
    accordion: {
      borderRadius: sys.borderRadius.xl,
      borderColor: sys.color.outline,
      multipleBorderColor: sys.color.outlineVariant,
      progressBar: {
        supportColors: {
          activeSupportColorOne: sys.color.supportOneNew,
          activeSupportColorTwo: sys.color.supportTwo,
          activeSupportColorThree: sys.color.supportThree,
          activeSupportColorFour: sys.color.supportFour,
          activeSupportColorFive: sys.color.supportFive,
          activeSupportColorSix: sys.color.supportSix,
          inactiveSupportColorOne: sys.color.supportOneNewVariant,
          inactiveSupportColorTwo: sys.color.supportTwoVariant,
          inactiveSupportColorThree: sys.color.supportThreeVariant,
          inactiveSupportColorFour: sys.color.supportFourVariant,
          inactiveSupportColorFive: sys.color.supportFiveVariant,
          inactiveSupportColorSix: sys.color.supportSixVariant,
        },
        supportPositiveColors: {
          activeSupportColorOne: sys.color.supportPositiveOne,
          activeSupportColorTwo: sys.color.supportPositiveTwo,
          activeSupportColorThree: sys.color.supportPositiveThree,
          activeSupportColorFour: sys.color.supportPositiveFour,
          activeSupportColorFive: sys.color.supportPositiveFive,
          activeSupportColorSix: sys.color.supportPositiveSix,
          inactiveSupportColorOne: sys.color.supportPositiveOneVariant,
          inactiveSupportColorTwo: sys.color.supportPositiveTwoVariant,
          inactiveSupportColorThree: sys.color.supportPositiveThreeVariant,
          inactiveSupportColorFour: sys.color.supportPositiveFourVariant,
          inactiveSupportColorFive: sys.color.supportPositiveFiveVariant,
          inactiveSupportColorSix: sys.color.supportPositiveSixVariant,
        },
        supportNegativeColors: {
          activeSupportColorOne: sys.color.supportNegativeOne,
          activeSupportColorTwo: sys.color.supportNegativeTwo,
          activeSupportColorThree: sys.color.supportNegativeThree,
          activeSupportColorFour: sys.color.supportNegativeFour,
          activeSupportColorFive: sys.color.supportNegativeFive,
          activeSupportColorSix: sys.color.supportNegativeSix,
          inactiveSupportColorOne: sys.color.supportNegativeOneVariant,
          inactiveSupportColorTwo: sys.color.supportNegativeTwoVariant,
          inactiveSupportColorThree: sys.color.supportNegativeThreeVariant,
          inactiveSupportColorFour: sys.color.supportNegativeFourVariant,
          inactiveSupportColorFive: sys.color.supportNegativeFiveVariant,
          inactiveSupportColorSix: sys.color.supportNegativeSixVariant,
        },
      },
    },
  };

  return comp;
};
